document.addEventListener('DOMContentLoaded', function () {
    const select = document.querySelector('select[name="your-individual"]');
    const hidden = document.querySelector('input[name="recipient-name"]');

    if (select && hidden) {
        select.addEventListener('change', function () {
            const selected = select.value;
            const nameOnly = selected.split('|')[0];
            hidden.value = nameOnly;
        });

        // Trigger once on load in case a value is already selected
        const selected = select.value;
        const nameOnly = selected.split('|')[0];
        hidden.value = nameOnly;
    }
});